// extracted by mini-css-extract-plugin
module.exports = {"List":"DraggableItem_List__3asWK","ListItem":"DraggableItem_ListItem__2cAMx"};